import loadable from "@loadable/component"

import {
  withFormMarketplace,
  withFormMobi,
  withFormMarketplaceMulti,
  withFormItauTudoazulTest,
  withFormDigio,
} from "@mkt/firebolt/config"

import { Button } from "iq-blueberry"
import DefaultLayout from "@mkt/cp/src/layout/DefaultLayout"
import ProductPageTemplate from "@mkt/cp/src/templates/ProductPage"

import Content from "./components/Content"

const CardsFeatured = loadable(() =>
  import("@mkt/cp/src/components/CardsFeatured")
)

const Card = ({ pageContext, location }) => {
  const CPLogo =
    "https://assets.iq.com.br/f/114280/64x64/98d908ee87/cp-logo-redirect.svg"

  return (
    <DefaultLayout pageContext={pageContext} location={location}>
      <ProductPageTemplate
        pageContext={pageContext}
        ComponentContent={Content}
        ComponentCardsFeatured={CardsFeatured}
        LogoRedirect={CPLogo}
        type="pdp"
        breadcrumbs={true}
        ComponentButton={Button}
      />
    </DefaultLayout>
  )
}

const withFormMarketplaceCard = withFormMarketplace(Card)
const withFormMarketplaceMultiCard = withFormMarketplaceMulti(Card)
const withFormMobiCard = withFormMobi(Card)
const withFormItauTudoazulTestCard = withFormItauTudoazulTest(Card)
const withFormDigioCard = withFormDigio(Card)

export {
  withFormMarketplaceCard,
  withFormMobiCard,
  withFormMarketplaceMultiCard,
  withFormDigioCard,
  withFormItauTudoazulTestCard
}
